<template>
    <main class="support">
        <primary-navigation />
        <div class="flex constrain bc">
            <h1>Get support from<br />Simulation Curriculum.</h1>
        </div>
        <div class="constrain bc">
            <div class="support-details flex">
                <div class="ff contact-form" ref="form">
                    <iframe width="100%" height="580" allowTransparency="true" frameborder="0" scrolling="no" style="border:none" src="https://www.emailmeform.com/builder/embed/P6ydW2dt15G2ME"><a href="https://www.emailmeform.com/builder/embed/P6ydW2dt15G2ME">Fill out form.</a></iframe>
                </div>
                <div class="ff support-options">
                    <div class="support-option">
                        <h3>Support Hours</h3>
                        <p>
                            We are available to provide help from Monday to Friday, 9:00 AM to 5:00 PM (CST).
                        </p>
                    </div>
                    <div class="support-option">
                        <h3>Information &amp; Order Inquiries</h3>
                        <p>
                            Please email us at info@simulationcurriculum.com or call us at 1-866-688-4175 (Toll Free).
                        </p>
                    </div>
                    <div class="support-option">
                        <h3>Technical Support</h3>
                        <p>
                            You can get help with technical issues by emailing us at support@simulationcurriculum.com.
                        </p>
                    </div>
                    <div class="support-option">
                        <h3>Snail Mail</h3>
                        <p>
                            We are located at: 11900 Wayzata Blvd. Ste. 126 Minnetonka, MN 55305.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'Support'
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .support-details
    {
        padding: 0 0 100px;
    }

    .support-option
    {
        padding: 20px 0 20px 50px;
    }

    h1
    {
        color: var(--primary-text-color);
        margin: 80px 0;
    }

    h3
    {
        font-size: 22px;
        line-height: 30px;
        margin-bottom: 4px;
        color: var(--primary-text-color);
    }

    p
    {
        font-size: 15px;
        color: var(--secondary-text-color);
        line-height: 20px;
    }

    .contact-form
    {
        border-radius: 3px;
        background: @f;
        padding: 0 20px;
    }
</style>